<template>
    <div class="container pb-5 pt-lg-8 pt-7">
        <div class="row pt-2">
            <div
                class="col-lg-6 product d-flex flex-column-reverse flex-md-row  align-items-center align-items-md-start justify-content-start border-0 pb-2"
            >
                <div class="d-flex flex-wrap flex-row flex-md-column justify-content-center pt-2 pt-md-0 gap-2">
                    <div
                        v-for="(image, i) in getProductBySlug($route.params.slug)
                            ?.images.slice(1,5)"
                        :key="image.id"
                        class="card-second-imgs-container me-2"
                        @click="index = i + 1;showLightBox=true"
                    >
                        <div class="card-second-imgs" :style="{backgroundImage: `url(${image?.url})`}">
                            <div class="show-more-images" v-if="i === 3">
                                +{{getProductBySlug($route.params.slug)?.images.length-4}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-img-container rounded-4">
                    <div
                        class="card-img-top"
                        :style="{backgroundImage: `url(${imageUrl
                            ? imageUrl
                            : getProductBySlug($route.params.slug)
                                ?.primaryImage.url})`}"
                        @click="index = 0;showLightBox=true"
                    />
                </div>
            </div>

            <div class="col-lg-6 product border-0">
                <div class="card-body text-lg-start">
                    <h5 class="card-title text-start mt-sm-2 pb-3">
                        {{ getProductBySlug($route.params.slug)?.name }}
                    </h5>
                    <span
                        v-for="(attribute, i) in getProductBySlug($route.params.slug)?.attributes"
                        :key="i"
                        class="card-text text-start d-flex align-items-center mb-1"
                    >
                        <img
                            v-if="
                                attribute.image.url
                            "
                            width="15"
                            class="ms-1"
                            :src="attribute.image.url"
                            alt=""
                        />
                        <span class="value mx-1  fw-bold">{{attribute.name}}:</span>
                        <div
                            class="value mx-2"
                            v-html="attribute.value"
                        ></div>
                        <br />
                    </span>
                    <!-- <span
                        class="card-text text-lg-start d-flex align-items-center my-2"
                    >
                        <img
                            v-if="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[1]?.image.url
                            "
                            width="20"
                            height="20"
                            class="ms-1 me-2"
                            :src="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[1]?.image.url
                            "
                            alt=""
                        />
                        <div
                            class="value"
                            v-html="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[1]?.value
                            "
                        ></div>
                    </span>
                    <span
                        class="card-text text-lg-start d-flex align-items-center mb-3"
                    >
                        <img
                            v-if="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[2]?.image.url
                            "
                            width="20"
                            height="20"
                            class="ms-1 me-2"
                            :src="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[2]?.image.url
                            "
                            alt=""
                        />
                        <div
                            class="value"
                            v-html="
                                getProductBySlug($route.params.slug)
                                    ?.attributes[2]?.value
                            "
                        ></div>
                    </span> -->
                    <div
                        v-html="
                            getProductBySlug(this.$route.params.slug)
                                ?.description
                        "
                        class="pt-2"
                    ></div>
                </div>
            </div>
        </div>

        <!-- related products -->

        <div class="container py-5 px-0">
            <h2 class="text-center fw-bold text-primary">
                {{ $t("related-products") }}
            </h2>
            <div
                class="products d-flex gap-4 flex-wrap justify-content-center pt-5"
                @click="imageUrl = null"
            >
                <div
                    v-for="product in products.filter(v => v.categoriesIds.includes(getProductBySlug($route.params.slug).categoriesIds[0]))?.slice(0,5)"
                    :key="product.id"
                >
                    <ProductCard
                        :product="product"
                    />
                </div>
            </div>
        </div>
        <VueEasyLightbox :visible="showLightBox" @hide="showLightBox=false" :index="index" :imgs="getProductBySlug($route.params.slug)?.images.map(v => v.url)"></VueEasyLightbox>
    </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ProductView',
  data () {
    return {
      imageUrl: null,
      showLightBox: false,
      index: 0
    }
  },
  components: { ProductCard, VueEasyLightbox },
  computed: {
    ...mapState({
      products: (state) => state.products.products
    }),
    ...mapGetters({
      getProductBySlug: 'products/getBySlug'
    })
  },
  created () {
    if (!this.products.length) {
      this.$store.dispatch('products/fetchAll').then(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
    .card-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(250, 249, 249);
        height: 500px;
        width: 80%;
        @media(max-width:576px) {
            height: 300px;
            width:90%;
        }
    }
    .card-second-imgs-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(250, 249, 249);
        border-radius: 1.2rem;
        height: 115px;
        width: 115px;
        cursor: pointer;
        .card-second-imgs {
            width:95%;
            height:95%;
            background-size: contain ;
            background-position: center;
            background-repeat: no-repeat;
            .show-more-images{
                height: 100%;
                width:100%;
                border-radius: 1.2rem;
                background: rgba(0,0,0,0.2);
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 25px;
                font-weight: 500;
                color: white;
            }
        }

    }
    .card-img-top {
        width:95%;
        height:95%;
        background-size: contain ;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .card-title{
        font-weight: 700;
        font-size: 35px;
        @media(max-width:768px) {
            font-size: 25px;
        }
    }
    .value{
        font-weight: 500;
    }
}

/* .card {
    width: 200px;
    .card-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(250, 249, 249);
        width: 80%;
        aspect-ratio: 0.75;
    }
} */
</style>
<style lang="scss">
.vel-img{
    background-color: rgb(250, 249, 249) !important;
    box-shadow: 0 0 20px 5px rgba(0,0,0,0.04) !important;
    border-radius: 15px;
}
</style>
